<template>
  <div class="submitted-deals">
    <div class="filterBox">
      <div class="filter" ref="operationRef">
        <div class="filter-item">
          <div class="filter-item-label">Time</div>
          <div class="filter-item-input">
            <a-date-picker v-model:value="filter.time" :allowClear="true" :getPopupContainer="() => $refs.operationRef"/>
               <!-- <artemisads-range-picker
              :allowClear="true"
              v-model:value="filter.time"
              :presets="RANGE_PRESETS"
              :getPopupContainer="() => $refs.operationRef"
            /> -->
          </div>
        </div>
        <div class="filter-item" ref="brandRef">
          <div class="filter-item-label">Brand</div>
          <div class="filter-item-input">
            <artmisads-input
              v-model:value="filter.brandName"
              placeholder="Brand"
            />
        
          </div>
        </div>
        <div class="filter-item" ref="marketplaceRef">
          <div class="filter-item-label">Marketplace</div>
          <div class="filter-item-input">
            <artmisads-select
              v-model:value="filter.marketplace"
              style="width: 232px"
              :options="marketplaceOptions"
              :show-arrow="false"
              placeholder="All"
              allowClear
              :getPopupContainer="() => marketplaceRef"
            />
          </div>
        </div>
       
      </div>
      <div class="btn-box">
        <artmisads-button type="primary" @click="handleReset"
          >Reset</artmisads-button
        >
        <artmisads-button type="primary" @click="handleSearch"
          >Search</artmisads-button
        >
      </div>
    </div>
    <div class="table-data">
      <div class="add-btn">
 <artmisads-button type="primary" @click="handleAdd" 
          >Add</artmisads-button
        >
      </div>
      
      <artmisads-table
        :pagination="param"
        :columns="columns"
        :data-source="data"
        :change="onTableChange"
        :loading="load"
        :scroll="{  y: tableScrollHeight }"
      >
        <template #bodyCell="{ column, text, index, record }">
          <template v-if="column.key === 'dealContent'">
             <a-tooltip placement="top">
        <template #title>
          <span>{{ record.dealContent }}</span>
        </template>
        <div class="content">
        {{ record.dealContent || '--' }}

        </div>
      </a-tooltip>
        
          </template>

          <template v-if="column.key === 'time'">
            {{
              record.createdAt
                ? moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss')
                : '--'
            }}
          </template>
          <template v-if="column.key === 'action'">
            <a @click="handleDelete(record)">
              Delete
            </a>
          </template>
        </template>
      </artmisads-table>
    </div>
    <addWhiteListModel ref="addWhiteListModelRef" @refreshList="getLsit"/>
  </div>
</template>
<script setup>
import { AMAZON_CURRENCY_MAPPER ,COUNTRY_BASE} from '~/contants/common'
import { ref } from 'vue'
import { publisherAdminApi } from '~/server/index'
import { RANGE_PRESETS } from '~/contants/reports'
import { useTableScrollHeight } from '@/utils/useTableScrollHeight'
import { message,Modal} from "ant-design-vue";
import addWhiteListModel from './addWhiteListModel.vue'
import moment from 'moment'
const param = ref({
  current: 1,
  pageSize: 10,
  total: 0,
})
// const marketplaceOptions = ref([])
const marketplaceRef=ref(null)
const marketplaceOptions = [
  { label: 'All', value: '' },
  ...COUNTRY_BASE.map((item) => ({
    label: item.host,
    value: item.host,
  })),
]
const addWhiteListModelRef = ref(null)
const startCreateTimestamp = ref('')
const endCreateTimestamp = ref('')
const filter = ref({
time:'',
brandName:"",
dealContent:"",
dmSubmittedDealId:""
})
const columns = ref([
  {
    title: 'Time',
    dataIndex: 'time',
    key: 'time',
  },
  {
    title: 'Brand',
    dataIndex: 'brandName',
    key: 'brandName',
  },
  {
    title:'Marketplace',
    dataIndex:'marketplace',
    key:'marketplace'
  },
  {
    title:'Action',
    dataIndex:'action',
    key:'action'
  }
])
const data = ref([])
const load = ref(false)

const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table-data',
  bottomSpace: 155,
  minHeight: 200,
  maxHeight: 800,
  defaultHeight: 350,
})
const handleReset = () => {
  filter.value = {
   time:'',
   brandName:"",
  }
  param.value.current=1
  startCreateTimestamp.value = ''
  endCreateTimestamp.value = ''

  getLsit()
}
const handleSearch = () => {
   if (filter.value.time) {
    startCreateTimestamp.value = moment(moment(filter.value.time).tz('US').format('YYYY-MM-DD')+' 00:00:00').valueOf()
    endCreateTimestamp.value =moment(moment(filter.value.time).tz('US').format('YYYY-MM-DD')+' 23:59:59').valueOf()
  }

  param.value.current=1
  getLsit()
}
const onTableChange = (pagination) => {
  param.value.current = pagination.current
  param.value.pageSize = pagination.pageSize
  getLsit()
}
const getLsit = async () => {
  load.value = true
  const res = await publisherAdminApi.getWhitelist({
    page: param.value.current,
    size: param.value.pageSize,
    startCreateTimestamp: startCreateTimestamp.value,
    endCreateTimestamp: endCreateTimestamp.value,
     ...filter.value,
  })
  load.value = false
  if (res.success) {
    data.value = res.data.data
    param.value.total = res.data.total
  }else{
    data.value = []
    param.value.total = 0
  }
}
const handleDelete = async (record) => {
 
  Modal.confirm({
    title: 'Are you sure delete this whitelist?',
    okText: 'Yes',
    okType: 'danger',
    onOk:  async () => {
      const res =await  publisherAdminApi.deleteWhitelist({
        id: record.id,
      })
      if (res.success) {
        getLsit()
        message.success('Delete success')
      }
    },
  })
}
const handleAdd = () => {
  addWhiteListModelRef.value.open()
}
getLsit()

</script>
<style scoped lang="less">
  .add-btn{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 10px 0;
  }
  .content{
    width: 180px;
display: -webkit-box;
  -webkit-line-clamp: 3; /* 限制行数为3 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  
  }
.submitted-deals {
  padding: 16px;

  width: 100%;
}
.table-data {

  border-radius: 8px;
  border: 1px solid #fff;
  border-radius: 12px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  padding: 15px;

}
.filterBox {
  padding: 15px 16px;
  margin: 16px 0;
  flex-wrap: wrap;
  border-radius: 8px;
  background: #fff;
}
.btn-box {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}
.filter {
  display: flex;
  gap: 22px;
  flex-wrap: wrap;
  .filter-item {
    display: flex;
    gap: 10px;
    align-items: center;
    .label {
      color: #0f0629;
      font-family: 'Sora';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;

      opacity: 0.9;
    }
  }
}
</style>
